import React, { useState, useEffect } from 'react';
import HomePage from './components/HomePage';
import ContactForm from './components/ContactForm';
import configFile from './config/config.json';
import { applySeasonalEffect } from './utils/seasonDetector';
import './App.css';

function App() {
  const [showContactForm, setShowContactForm] = useState(false);
  const [config, setConfig] = useState(configFile);

  useEffect(() => {
    // Appliquer la détection saisonnière si nécessaire
    const updatedConfig = applySeasonalEffect(configFile);
    setConfig(updatedConfig);

    // Appliquer les couleurs au document
    document.documentElement.style.setProperty('--primary-color', updatedConfig.primaryColor);
    document.documentElement.style.setProperty('--secondary-color', updatedConfig.secondaryColor);
  }, []);

  return (
    <div className="App">
      <HomePage 
        config={config} 
        onContactClick={() => setShowContactForm(true)}
      />
      
      {showContactForm && (
        <ContactForm 
          config={config} 
          onClose={() => setShowContactForm(false)}
        />
      )}
    </div>
  );
}

export default App;